(function() {
  'use strict';

  angular.module('app').controller('ResellerController', ResellerController);

  ResellerController.$inject = [
    '$scope', '$rootScope', '$timeout', '$filter',
    'blockUI', '$uibModal',
    'ResellerService', 'SelectService', 'CustomerService', 'BusinessService',
    'LoyaltyService'];

  function ResellerController($scope, $rootScope, $timeout, $filter,
      blockUI, $uibModal,
      ResellerService, SelectService, CustomerService, BusinessService,
      LoyaltyService) {

    $scope.getPages = getTotalPaginatedPages;
    $scope.getBusinesses = getBusinesses;
    $scope.getBusinessStatusDescription = getBusinessStatusDescription;

    $scope.params = {
      businesses_preset: {
        page: 1,
        count: 20,
        sort_order: 'ASC',
        sort_field: 'business_title'
      }
    };

    $scope.data = {
      showTableDisplaySettings: false,
      isFilePreparing: false,
      summary: {},
      pagerLengths: [10, 20, 50, 100, 200]
    };

    $scope.data.table_cols_preset = [
      {
        visible: true,
        enabled: true,
        data: [
          {value: 'business_code', text: 'TEXT_LIST_BUSINESS_CODE', visible: true},
          {value: 'business_title', text: 'TEXT_LIST_BUSINESS_TITLE', visible: true}
        ]
      },
      {
        visible: true,
        enabled: true,
        data: [
          {value: 'user_name', text: 'TEXT_LIST_BUSINESS_OWNER_NAME', visible: true},
          {value: 'user_login', text: 'TEXT_LIST_BUSINESS_OWNER_EMAIL', visible: true},
          {value: 'user_phone', text: 'TEXT_LIST_BUSINESS_OWNER_PHONE', visible: true}
        ]
      },
      {
        visible: true,
        enabled: true,
        data: [
          {value: 'business_active', text: 'TEXT_LIST_BUSINESS_ACTIVE', visible: true}
        ]
      },
      {
        visible: true,
        enabled: true,
        data: [
          {value: 'business_currency', text: 'TEXT_LIST_BUSINESS_CURRENCY', visible: true}
        ]
      },
      {
        visible: true,
        enabled: true,
        data: [
          {value: 'business_account_balance', text: 'TEXT_LIST_BUSINESS_BALANCE', visible: true}
        ]
      },
      {
        visible: true,
        enabled: true,
        data: [
          {value: 'business_credit_limit', text: 'TEXT_LIST_BUSINESS_CREDIT_LIMIT', visible: true}
        ]
      },
      {
        visible: true,
        enabled: true,
        data: [
          {value: 'actions', text: 'Actions', visible: true, not_sortable: true}
        ]
      }
    ];

    var block_businesses_list = blockUI.instances.get('reseller_businesses_list');
    var filterTimeout;

    initController();

    function initBusinessFiters() {

      // if ($rootScope.ENV.filters.reseller_businesses_list) {
      //     try {
      //         $scope.params.businesses = JSON.parse($rootScope.ENV.filters.reseller_businesses_list.params);
      //
      //         $scope.params.businesses.page = 1;
      //     } catch (e) {
      //
      //         $scope.params.businesses = angular.copy($scope.params.businesses_preset);
      //         $rootScope.ENV.filters.reseller_businesses_list = {params: JSON.stringify($scope.params.businesses)};
      //         // $rootScope.ENV.filters.reseller_businesses_list.params = JSON.stringify($scope.params.businesses);
      //         $rootScope.storeENV();
      //     }
      // }
      // else {
      //     $scope.params.businesses = angular.copy($scope.params.businesses_preset);
      //     $rootScope.ENV.filters.reseller_businesses_list = {};
      //     $rootScope.storeENV();
      // }

      $scope.params.businesses = angular.copy($scope.params.businesses_preset);
      $rootScope.ENV.filters.reseller_businesses_list = {};
      $rootScope.storeENV();
    }

    function initTableColumns() {
      try {
        $scope.data.table_cols = JSON.parse($rootScope.ENV.filters.reseller_businesses_list.table_cols);
      } catch (e) {
        $scope.data.table_cols = angular.copy($scope.data.table_cols_preset);
      }
    }

    function initController() {
      initBusinessFiters();
      _doShow();
    }

    function _doShow() {
      getBusinesses();

      function s() {
        $timeout(s, 250);
      }

      s();
    }

    function getBusinesses() {
      initTableColumns();

      var params = angular.copy($scope.params.businesses);

      params = cleanRequestData(params);

      block_businesses_list.start();
      ResellerService.AllBusiness(params, function(success, response) {
        if (success) {
          $scope.data.businessesList = response.data;
          $scope.data.summary = response.summary;

          $rootScope.ENV.filters.reseller_businesses_list.params = JSON.stringify($scope.params.businesses);
          $rootScope.storeENV();
        }
        block_businesses_list.stop();
      });
    }

    function getBusinessStatusDescription(active) {
      var res;
      if (active) {
        res = 'TEXT_BUSINESS_STATUS_ACTIVE';
      } else {
        res = 'TEXT_BUSINESS_STATUS_SUSPENDED';
      }
      return res;
    }

    $scope.getTableHeaderClass = function(row) {
      return {
        'sorting_asc': $scope.params.businesses.sort_field == row.value && $scope.params.businesses.sort_order == 'ASC',
        'sorting_desc': $scope.params.businesses.sort_field == row.value && $scope.params.businesses.sort_order == 'DESC',
        'sorting': !row.not_sortable
      };
    };

    $scope.onSortOrderChange = function(field) {
      if ($scope.params.businesses.sort_field === field)
        $scope.params.businesses.sort_order = $scope.params.businesses.sort_order == 'ASC' ? 'DESC' : 'ASC';

      $scope.params.businesses.sort_field = field;

      getBusinesses();
    };

    $scope.pageChange = function() {
      getBusinesses();
    };

    $scope.onCountChange = function(count) {
      $scope.params.businesses.page = 1;
      $scope.params.businesses.count = count;
      getBusinesses();
    };

    $scope.onDisplaySettingsClick = function() {
      if ($scope.data.showTableDisplaySettings) {
        $rootScope.ENV.filters.reseller_businesses_list.table_cols = JSON.stringify($scope.data.table_cols);
        $rootScope.storeENV();
      }

      $scope.data.showTableDisplaySettings = !$scope.data.showTableDisplaySettings;
    };

    $scope.onDisplaySettingsSave = function() {
      // $rootScope.ENV.filters.reseller_businesses_list.table_cols = JSON.stringify($scope.data.table_cols);
      // $rootScope.storeENV();
      $scope.onDisplaySettingsClick();
    };

    $scope.onColumnDisplayChange = function(index) {
      for (var i in $scope.data.table_cols[index].data)
        $scope.data.table_cols[index].data[i].visible = $scope.data.table_cols[index].visible;
    };

    $scope.onColumnDataDisplayChange = function(index) {
      $scope.data.table_cols.forEach(function(column) {
        column.visible = column.data.some(function(data) {
          return data.visible;
        });
      });
    };

    $scope.onColumnAdd = function(first) {
      if (first)
        $scope.data.table_cols.unshift({visible: true, data: []});
      else
        $scope.data.table_cols.push({visible: true, data: []});
    };

    $scope.onColumnsReset = function() {
      initTableColumns();
    };

    $scope.onColumnRemove = function(index) {
      $scope.data.table_cols.splice(index, 1);
    };

    $scope.onBusinessRefill = function(id) {

      var amount = document.getElementById('refillAmount-' + id);

      if (amount.value) {
        var post_data = {
          amount: parseFloat(amount.value)
        };

        ResellerService.RefillBusiness(id, post_data, function(success, response) {
          if (success) {
            getBusinesses();
          }
        });
      }
    };

    // $scope.$watchCollection('[params.businesses.search]', function(newCollection, oldCollection) {
    //     if (newCollection && newCollection !== oldCollection) {
    //         if (filterTimeout)
    //             $timeout.cancel(filterTimeout);
    //
    //         filterTimeout = $timeout(function() {
    //             $scope.params.businesses.page = 1;
    //
    //             getBusinesses();
    //         }, 1000);
    //     }
    // });
  }
})();
